import { lccstore } from '@holmescorp/lcc-state';
import { XAPI } from '@holmescorp/xapi';
const recordInteraction = (details) => {
    const { association, product, activity } = details;
    const target = new XAPI.Activity({ id: activity });
    const verb = XAPI.Verbs.EXPERIENCED;
    const context = new XAPI.Context({
        extensions: { 'urn:holmes:activity:storyline': `${association}-${product}-${activity}` }
    });
    const actor = lccstore.get(lccstore.path('actor_xapi'));
    const statement = new XAPI.Statement({ actor, target, context, verb }).asVersion();
    return XAPI.svc.set_statement({ stmnt: statement });
};
export const handleActivityInteraction = async (activity) => {
    const { association = '', product = '' } = window.hcstatic;
    await recordInteraction({ association, product, activity });
};
